/**
 * Isomorphic SSR-safe check if code is run in the browser environment
 * so we can use globals like window safely.
 */
export const isBrowser = (): boolean => {
	try {
		return typeof window !== 'undefined';
	} catch {
		// Catch possible error that might occur and just return false
		return false;
	}
};
